export default __webpack_public_path__ + "static/media/oms.0b59fc34.png";